import AOS from "aos";
import "aos/dist/aos.css";

import Banner from "../Banner/Banner";
import Blogs from "../Blogs/Blogs";
import Footer from "../Footer/Footer";
import Hero from "../Hero.jsx/Hero";
// import Navbar from "./components/navbar/Navbar";
import Navbar2 from "../navbar/Navbar2";
import { useEffect } from "react";
import BannerDetails from "../BannerDetails/BannerDetails";
import Partners from "../Partners/Partners";
import AreasOfPractice from "../AreasOfPractice/AreasOfPractice";
import Testimonials from "../Testimonials/Testimonials";
import Layout from "../Layout/Layout";

function App() {
  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 500,
      easing: "ease-in-sine",
      delay: 100,
    });
    AOS.refresh();
  }, []);
  return (
    <>
      {/* <div className="fixed left-0 right-0 top-0 z-50 bg-gradient-to-l from-violet-900 via-violet-800 to-violet-900 ">
       
          <Navbar2 />
        </div> */}
      <Layout
        title="Lawyer Aderaw | Lawyer and Legal Consultant in Bahir Dar Ethiopia"
        description="Learn about Aderaw Addisu Law Office, a trusted law firm in Bahir Dar providing litigation, arbitration, property, contract and business legal services."
        keywords="About Aderaw Addisu, Lawyer in Bahir Dar, Law Office Ethiopia"
      >
        <Hero />

        <Blogs />
        {/* <BookingList /> */}
        <AreasOfPractice />
        <BannerDetails reverse={true} />
        <Partners />
        <Banner />

        <Testimonials />
      </Layout>
    </>
  );
}

export default App;
